import React, { ReactElement, useState } from 'react';
import { IconType } from 'react-icons';
import { FaCopy } from 'react-icons/fa';
import { ClipboardHelper } from '../../../helpers/ClipboardHelper';
import { Grid } from '@material-ui/core';
import { useAppTranslation } from 'hooks';

interface AttributeProps {
  active: boolean;
  name: string;
  value: string;
  icon: ReactElement<IconType>;
}

export const Attribute = ({ active, name, value, icon }: AttributeProps) => {
  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    e.dataTransfer.setData('text/plain', name);
    e.dataTransfer.dropEffect = 'move';
  };
  const [t] = useAppTranslation('COMMONS');

  const [copied, setCopied] = useState(false);

  const handleClipboardClick = async () => {
    await ClipboardHelper.copyToClipboard(name);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <Grid container className={active ? 'active' : ''} style={{alignItems: 'center'}} draggable={true} onDragStart={handleDragStart}>
      <Grid item md={1} style={{textAlign: 'left'}}>
        <h4>{icon}</h4>
      </Grid>
      <Grid item md={10}>
        <span style={{display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
          <h4>{name}</h4>
          <p style={{margin: '0'}}>{value}</p>
        </span>
      </Grid>
      <Grid item md={1} style={{textAlign: 'right', position: 'relative'}}>
        <h4><FaCopy style={{ cursor: 'pointer' }} onClick={handleClipboardClick} /></h4>
        {copied && (
        <span style={{
          position: 'absolute',
          top: '-20px',
          right: '0',
          fontSize: '12px',
          color: '#4caf50',
          fontWeight: 'bold'
        }} >
          {t('COPIED')}
        </span>
      )}
      </Grid>
    </Grid>
  );
};